module.exports = __webpack_public_path__ + "static/media/warning-red.7b6153b3.svg";